import { alertWarningBehavior } from './alertWarningBehavior';
import { alertBaseBehavior } from './alertBaseBehavior';
/**
 * @description
 * Uses `alertWarningBehavior` for 'danger' and 'warning' variants.
 */

export var alertBehavior = function alertBehavior(props) {
  return props.warning || props.danger ? alertWarningBehavior(props) : alertBaseBehavior(props);
};
//# sourceMappingURL=alertBehavior.js.map
